export default __webpack_public_path__ + "static/media/ic-chevron-down.5343c655.svg";